export default __webpack_public_path__ + "static/media/report.e4c6d439.svg";